// extracted by mini-css-extract-plugin
module.exports = {"text":"AgreementsTemplate_text__vUNfp"};